<template>
    <div>
        <CatSlider
                v-if="catList.length > 0"
                :catList="catList"
                :defaultIndex="0"
                @clickTab="onSelectCat($event)"
                data-cy="component_category_list_cat_slider"
        ></CatSlider>
        <div class="mt-3" data-cy="container_category_list_content">
            <CampaignList
                    ref="campaign-list"
                    v-if="campaignListConfig != null && campaignListFilter != null"
                    :initListConfig="campaignListConfig"
                    :initFilterConfig="campaignListFilter"
                    :modalController="modalController"
                    data-cy="component_category_list_campaign_list"
            ></CampaignList>
        </div>
    </div>
</template>
<script>
import Util from '@/helper/Utility.js';
//component
import CatSlider from './CatSlider.vue';
import CampaignList from '../CampaignList/CampaignList.vue';
//service
import BzbsCategory from '@/core/Campaign/service/BzbsCategory.js';
import {
    CampaignListConfigBuilder,
    CampaignListFilterConfigBuilder
} from "@/core/Campaign/config/CampaignConfigModel.js";

export default {
    name: 'CategoryList',
    components: {
        CatSlider,
        CampaignList,
    },
    props: {
        categoryConfig:  { type: Object, required: true },
        modalController: { type: Object, required: true },
    },
    data: function() {
        return {
            catList: [],
            selectedCat: null,

            campaignListConfig: null,
            campaignListFilter: null,
        };
    },
    created: function() {
        this.initList();
    },
    methods: {
        initList: async function() {
            await this.getCategory();

            let catIdParams = this.$route.params.catId;
            if (!Util.isEmptyStr(catIdParams)) {
                let cat = this.catList.find((item) => item.id == catIdParams);
                this.selectedCat = cat != null ? cat : this.catList[0];
            } else {
                this.selectedCat = this.catList[0];
            }

            this.setCampaignList();
        },

        getCategory: function() {
            return new Promise((resolve) => {
                var categoryParam = this.categoryConfig.getParams();

                BzbsCategory.apiGetCategory(categoryParam).subscribe((categories) => {
                    this.catList = categories;
                    resolve();
                }, (err) => {
                    resolve();
                    this.errorApi(err);
                });
            });
        },

        setCampaignList: function() {
            this.campaignListConfig = null;
            this.campaignListFilter = null;

            let listConfig = new CampaignListConfigBuilder()
                            .setConfigList(this.selectedCat.listConfig)
                            .setTop(25);
            if (this.selectedCat.id) {
                listConfig.setCatId(this.selectedCat.id);
            }
            this.campaignListConfig = listConfig.create();

            let filterConfig = new CampaignListFilterConfigBuilder();
            this.campaignListFilter = filterConfig.create();
        },

        loadMore: function() {
            this.$refs['campaign-list'].loadMore();
        },

        onSelectCat: function(data) {
            this.selectedCat = data.cat;
            this.setCampaignList();
            this.$refs['campaign-list'].reinitList(this.campaignListConfig, this.campaignListFilter);
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
